import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import './styles/index.css'
import App from './App'
import store from './store'
import {BrowserRouter} from 'react-router-dom'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <React.StrictMode>
      <Provider store = {store}>
        <App />
      </Provider>
    </React.StrictMode>
  </BrowserRouter>
)
